module.exports = __webpack_public_path__ + "static/media/paper-7-1024x682.398eb43d.jpg";